import { RootState } from '../../../applicationStore';
import { OrderState } from '../reducers';
import { createSelector } from '@reduxjs/toolkit';

export const getOrderState = (state: RootState): OrderState => state.order;

export const getOrderLoader = createSelector(
  getOrderState,
  (state): boolean => state.loading,
);

export const getOrderData = createSelector(
  getOrderState,
  (state): OrderState['data'] | null => state?.data || null,
);
